var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"figure figure--avatar",class:{ 'figure--icon': _vm.icon }},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.name}}):_vm._e(),(!_vm.icon)?_c('div',[_vm._v(" "+_vm._s(_vm.name.charAt(0))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }